import React, { InputHTMLAttributes, useEffect, useRef } from 'react';
import { Input, Column, TagError, IconCheck } from './styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  errorMessage?: string;
  height: string;
  placeholder?: string;
  readOnly?: boolean;
  telephoneAccept?: boolean;
  maxLength?: number;
  max?: string;
  handlerOnchange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  focus?: string | undefined;
  newData?: boolean;
  isChildren?: boolean;
  newContact?: boolean;
  style?: React.CSSProperties;
}

function InputComponent({
  onBlur,
  type,
  value,
  error,
  errorMessage,
  height,
  placeholder,
  readOnly,
  maxLength,
  telephoneAccept,
  max,
  handlerOnchange,
  focus,
  newData,
  isChildren,
  newContact,
  style,
}: InputProps) {
  const autoFocus = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (focus && focus === 'FOCUS_INPUT_PHONE') {
      if (autoFocus.current) autoFocus.current.focus();
    }
  });

  useEffect(() => {
    if (newContact) {
      if (autoFocus.current) autoFocus.current.focus();
    }
  }, [newContact]);

  return (
    <Column
      error={error}
      height={height}
      newData={newData}
      isChildren={isChildren}
      style={style}
    >
      <Input
        onChange={handlerOnchange}
        onBlur={onBlur}
        value={value}
        type={type}
        placeholder={placeholder}
        maxLength={maxLength}
        readOnly={readOnly}
        ref={autoFocus}
        max={max}
        newData={newData}
        isChildren={isChildren}
      />
      {telephoneAccept && <IconCheck />}
      {error && <TagError>{errorMessage}</TagError>}
    </Column>
  );
}
export default InputComponent;
